module.exports = __webpack_public_path__ + "static/media/fran.c11983ea.jpg";